import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  MenuItem,
} from "@mui/material";

export default function AddUserForm({ addDialog, setAddDialog, addUserForm }) {
  return (
    <Dialog
      open={addDialog.open}
      onClose={() => setAddDialog({ open: false })}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Add New User</DialogTitle>
      <form onSubmit={addUserForm.handleSubmit}>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Name"
                name="firstName"
                value={addUserForm.values.firstName}
                onChange={addUserForm.handleChange}
                onBlur={addUserForm.handleBlur}
                error={
                  addUserForm.touched.firstName &&
                  Boolean(addUserForm.errors.firstName)
                }
                helperText={
                  addUserForm.touched.firstName && addUserForm.errors.firstName
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                value={addUserForm.values.lastName}
                onChange={addUserForm.handleChange}
                onBlur={addUserForm.handleBlur}
                error={
                  addUserForm.touched.lastName &&
                  Boolean(addUserForm.errors.lastName)
                }
                helperText={
                  addUserForm.touched.lastName && addUserForm.errors.lastName
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Username"
                name="username"
                value={addUserForm.values.username}
                onChange={addUserForm.handleChange}
                onBlur={addUserForm.handleBlur}
                error={
                  addUserForm.touched.username &&
                  Boolean(addUserForm.errors.username)
                }
                helperText={
                  addUserForm.touched.username && addUserForm.errors.username
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Role"
                name="role"
                value={addUserForm.values.role}
                onChange={addUserForm.handleChange}
                onBlur={addUserForm.handleBlur}
                error={
                  addUserForm.touched.role && Boolean(addUserForm.errors.role)
                }
                helperText={addUserForm.touched.role && addUserForm.errors.role}
              >
                <MenuItem value="student">Student</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                label="Class Code"
                name="classCode"
                value={addUserForm.values.classCode}
                onChange={addUserForm.handleChange}
                onBlur={addUserForm.handleBlur}
                error={
                  addUserForm.touched.classCode &&
                  Boolean(addUserForm.errors.classCode)
                }
                helperText={
                  addUserForm.touched.classCode && addUserForm.errors.classCode
                }
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                label="Email (Optional)"
                name="email"
                type="email"
                value={addUserForm.values.email}
                onChange={addUserForm.handleChange}
                onBlur={addUserForm.handleBlur}
                error={
                  addUserForm.touched.email && Boolean(addUserForm.errors.email)
                }
                helperText={
                  addUserForm.touched.email && addUserForm.errors.email
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Password"
                name="password"
                type="password"
                value={addUserForm.values.password}
                onChange={addUserForm.handleChange}
                onBlur={addUserForm.handleBlur}
                error={
                  addUserForm.touched.password &&
                  Boolean(addUserForm.errors.password)
                }
                helperText={
                  addUserForm.touched.password && addUserForm.errors.password
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button
            onClick={() => setAddDialog({ open: false })}
            variant="outlined"
            color="inherit"
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3,
              py: 1,
              borderColor: "grey.300",
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3,
              py: 1,
              boxShadow: 2,
              "&:hover": {
                boxShadow: 4,
              },
            }}
          >
            Create User
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
